import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2, ShieldCheck, Leaf, Sparkles } from 'lucide-react';
import { Button } from './ui/Button';
export function Hero() {
  const pills = ['PDF Digital', 'Acceso Inmediato', 'Recetas fáciles y saludables', 'Para toda la familia'];
  return <section className="relative pt-20 pb-16 md:pt-32 md:pb-24 overflow-hidden px-4" data-id="element-70">
      {/* Decorative elements */}
      <div className="absolute top-10 left-10 text-sage/20 hidden md:block" data-id="element-71">
        <Leaf className="w-24 h-24 -rotate-12" data-id="element-72" />
      </div>
      <div className="absolute bottom-20 right-10 text-terracotta/20 hidden md:block" data-id="element-73">
        <Sparkles className="w-20 h-20" data-id="element-74" />
      </div>

      <div className="max-w-4xl mx-auto text-center relative z-10" data-id="element-75">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} data-id="element-76">
          <span className="inline-block py-1 px-3 rounded-full bg-terracotta/10 text-terracotta font-semibold text-sm tracking-wide mb-6" data-id="element-77">
            6 Módulos + 6 Bonos Exclusivos
          </span>

          <h1 className="font-serif text-5xl md:text-7xl text-forest tracking-tight leading-tight mb-4" data-id="element-78">
            RECETAS SALUDABLES PARA CELÍACOS
          </h1>

          <h2 className="text-2xl md:text-3xl text-sage font-medium mb-8" data-id="element-79">
            Tu Alimentación Sin Gluten Resuelta
          </h2>

          <p className="text-lg md:text-xl text-muted max-w-3xl mx-auto leading-relaxed mb-10" data-id="element-80">
            Tu sistema completo de alimentación saludable sin gluten listo para
            usar: recetas, planificación, colaciones, hábitos saludables y
            organización diaria. Sin estrés, sin improvisar y sin poner en
            riesgo tu salud.
          </p>

          <div className="flex flex-wrap justify-center gap-3 mb-12" data-id="element-81">
            {pills.map((pill, idx) => <span key={idx} className="flex items-center gap-2 bg-warm-white px-4 py-2 rounded-full text-sm font-medium text-forest shadow-sm border border-sage/10" data-id="element-82">
                <CheckCircle2 className="w-4 h-4 text-sage" data-id="element-83" />
                {pill}
              </span>)}
          </div>

          <div className="flex flex-col items-center gap-6" data-id="element-84">
            <Button href="#precio" className="w-full md:w-auto md:px-12 md:py-5 text-lg md:text-xl" data-id="element-85">
              QUIERO MI ALIMENTACIÓN SALUDABLE AHORA
            </Button>

            <div className="flex items-center gap-2 text-sm text-muted font-medium" data-id="element-86">
              <ShieldCheck className="w-4 h-4 text-sage" data-id="element-87" />
              Pago seguro Mercado Pago · Miles de personas mejorando su vida sin
              gluten 💚
            </div>

            <div className="flex gap-4 mt-2" data-id="element-88">
              <span className="text-xs font-semibold uppercase tracking-wider text-sage bg-sage/10 px-3 py-1 rounded-full" data-id="element-89">
                100% Libre de Gluten
              </span>
              <span className="text-xs font-semibold uppercase tracking-wider text-sage bg-sage/10 px-3 py-1 rounded-full" data-id="element-90">
                Recetas probadas y seguras
              </span>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}